import React, { ChangeEvent, useEffect, useState } from "react";
import "./DCTextArea.scss";
import { ReactSVG } from "react-svg";

//Component properties interface
interface DCTextAreaProps {
  value: string;
  maxLength: number;
  placeholder: string;
  required?: boolean;
  disable: boolean;
  onInputChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onClickSave?: boolean;
  spellcheck?: boolean;
}

export const DCTextArea = ({
  value,
  maxLength,
  placeholder,
  required = true,
  disable,
  onInputChange,
  onClickSave,
  spellcheck = true,
}: DCTextAreaProps) => {
  const [inputValue, setInputValue] = useState<string>(value);
  const [isValid, setIsValid] = useState<boolean>(true);
  const [touch, setTouch] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState('');
  useEffect(() => {
    // Add your validation logic here
    if (required && inputValue.length === 0 && (touch || onClickSave)) {
      setIsValid(false);
    } else {
      setIsValid(true);

    }

    if (maxLength > 0 && inputValue.length < maxLength) {
      setWarningMessage('');
    }
  }, [inputValue, required,onClickSave]); // Dependency
  
  useEffect(() => {
    setInputValue(value);
  });
  
  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    const pasteData = e.clipboardData.getData('text');
    if ((pasteData.length > maxLength) ||(pasteData.length + inputValue.length > maxLength)) {
      setWarningMessage(`The content exceeds the maximum length of ${maxLength} characters. Hence, the content has been truncated.`);
    } else {
      setWarningMessage('');
    }
  };

  
  return (
    <>
      <div className="FlexSingleColumn">
        <div
          className={
            isValid
              ? `DCTextAreaInput DCTextAreaInputValid ${disable ? 'DCTextAreaInputDisabled' : ''} ${warningMessage ? 'DCTextAreaInputWarning' : ''}`
              : `DCTextAreaInput DCTextAreaInputNotValid ${disable ? 'DCTextAreaInputDisabled' : ''} ${warningMessage ? 'DCTextAreaInputWarning' : ''}`
          }
        >
        <div className="textarea-container">
          <span>{placeholder}</span>
          {maxLength > 0 ? (
            <span id="contentLen">
              {inputValue.length}/{maxLength}
            </span>
          ) : null}
          </div>
          {isValid ? null : (
            <div id="errorIcon">
              <ReactSVG src="https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/alert/error.svg" />
            </div>
          )}
          <textarea
            data-testid="dcTextAreaInput"
            maxLength={maxLength}
            value={value}
            disabled={disable}
            spellCheck={spellcheck}
            onInput={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              setInputValue(e.target.value);
              setTouch(true);
              onInputChange(e);
            }}
            onBlur={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              required
                ? setIsValid(e.target.value.length > 0)
                : setIsValid(true);
              setTouch(true);
            }}
            onPaste={handlePaste}
          ></textarea>
        </div>
        {isValid ? null : (
          <div id="errorMessage">Please fill out this field.</div>
        )}
        {warningMessage && (
          <div className="warning-container">
            <div id="warningMessage">
              {warningMessage}
            </div>
            <div className="closeBtn" role='button' aria-label='x-sm' 
                tabIndex={0}
                onClick={() => setWarningMessage('')}
                onKeyDown={e => {
                  if (e.key === 'Enter' ) {   }
                }}
            >
            </div>
          </div>
        )}
      </div>
    </>
  );
};
